import "../redactor/redactor.min";
import "../redactor/alignment.min";
import "../redactor/table.min";
import "../redactor/handle.min";
import "../redactor/redactor_button";
import "../redactor/redactor_deal_card";
import "../redactor/redactor_embedded";
// import "../redactor/redactor_google_ads";
import "../redactor/nofollow";
import "../redactor/emoji_icons";
import "../redactor/redactor_emoji";
import "../redactor/ru";
import { showToast } from './notification_toast';
import { emojiMap } from './emoji_utils';

/**
 * Returns the Redactor language code based on current locale.
 * Defaults to English (no lang needed) if locale is 'en'.
 */
function getRedactorLang() {
  const locale = document.documentElement.dataset.locale || I18n?.locale || 'ru';
  // Redactor uses 'ru' for Russian, English is default (undefined)
  return locale === 'ru' ? 'ru' : undefined;
}

$R.plugins.handle.prototype._load = function () {
  fetch(`${this.opts.handle}?term=${encodeURIComponent(this.handleStr)}`, {
    method: "GET",
    credentials: "include" // Keeps it identical to jQuery
  })
  .then(response => response.json())
  .then(data => {
    this._parse(data);
  })
  .catch(error => console.error("Fetch error:", error));
};

$R.plugins.handle.prototype._update = function () {
  if (!this.$list) {
    var listElement = document.createElement("div");
    listElement.id = "mentionContainer";
    listElement.className = "mention-container";
    this.$list = $R.dom(listElement);
    $R.dom("body").append(this.$list);
  }

  this.$list.html("");

  for (var key in this.data) {
    if (this.data.hasOwnProperty(key)) {
      var itemElement = document.createElement("a");
      itemElement.href = "#";
      itemElement.className = "mention-item";
      itemElement.innerHTML =
        "<img src='" +
        this.data[key].img +
        "' class='mention-item-img'>" +
        "<span class='mention-item-label'>" +
        this.data[key].label +
        "</span>";

      var $item = $R.dom(itemElement);
      $item.attr("data-key", key);

      $item.on(
        "click",
        (function (key) {
          return function (e) {
            e.preventDefault();
            this._replace(e, key);
          }.bind(this);
        }).call(this, key)
      );

      this.$list.append($item);
    }
  }

  var $container = this.container.getElement();
  var pos = this.selection.getPosition();
  this.$list.css({
    position: "absolute",
    top: pos.top + pos.height + this.$doc.scrollTop() + "px",
    left: pos.left + "px",
    zIndex: 1000,
    backgroundColor: "white",
    border: "1px solid #ddd",
    borderRadius: "4px",
    width: "250px",
    minHeight: "100px",
    maxHeight: "200px",
    overflowY: "auto",
    overflowX: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  });

  if (!document.getElementById("mentionStyles")) {
    var style = document.createElement("style");
    style.id = "mentionStyles";
    style.type = "text/css";
    style.innerHTML = `
      .mention-container {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        white-space: nowrap;
      }
    `;
    document.head.appendChild(style);
  }
};

$R.plugins.handle.prototype._replace = function (e, keyOrEl) {
  e.preventDefault();

  // Handle both click (key is a string/number) and keyboard Enter (key is a DOM element)
  var key = keyOrEl;
  if (typeof keyOrEl === 'object' && keyOrEl !== null) {
    // DOM element from _listen's Enter handler - extract data-key attribute
    var el = (keyOrEl.get) ? keyOrEl.get(0) || keyOrEl.get() : keyOrEl;
    if (el && el.getAttribute) {
      key = el.getAttribute('data-key');
    } else if (keyOrEl.attr) {
      key = keyOrEl.attr('data-key');
    }
  }

  if (!this.data[key]) return;

  var label = this.data[key].label;
  var replacement = " @" + label + " ";
  var marker = this.marker.insert("start");
  var $marker = $R.dom(marker);
  var current = marker.previousSibling;
  if (!current) {
    $marker.before(replacement);
    this.selection.restoreMarkers();
    return;
  }
  var currentText = current.textContent;

  var re = new RegExp("@" + this.handleStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + "$");
  currentText = currentText.replace(re, "");
  current.textContent = currentText;

  $marker.before(replacement);
  this.selection.restoreMarkers();
};

$R.plugins.handle.prototype._parse = function (json) {
  if (json === "") return;

  var data = typeof json === "object" ? json : JSON.parse(json);

  this._build();
  this._buildData(data);
};

$R.plugins.handle.prototype._build = function () {
  var listElement = document.querySelector("#redactor-handle-list");
  if (!listElement) {
    listElement = document.createElement("div");
    listElement.id = "redactor-handle-list";
    $R.dom("body").append($R.dom(listElement));
  }
  this.$list = $R.dom(listElement);
};

$R.plugins.handle.prototype._buildData = function (data) {
  this.data = data;
  this._update();
  this._show();
};



// Helper function to unwrap emoji images from figures
function unwrapEmojiImages(container) {
  const emojiImages = container.querySelectorAll('img[src*="emojis"]');
  emojiImages.forEach(img => {
    const figure = img.closest('figure');
    if (figure) {
      // Ensure img has contenteditable like toolbar emojis
      if (!img.hasAttribute('contenteditable')) {
        img.setAttribute('contenteditable', 'true');
      }

      // Replace figure with just the img
      figure.parentNode.insertBefore(img, figure);
      figure.remove();
    }
  });
}

// Simple emoji figure cleanup for legacy Redactor
let emojiCleanupSetup = false;
function setupLegacyEmojiCleanup() {
  if (emojiCleanupSetup) return;
  emojiCleanupSetup = true;

  // Use DOM events instead of Redactor callbacks
  document.addEventListener('paste', function(e) {
    const activeElement = document.activeElement;
    const isRedactorEditor = activeElement && (
      activeElement.classList.contains('redactor-editor') ||
      activeElement.closest('.redactor-editor')
    );

    if (!isRedactorEditor) return;

    setTimeout(() => {
      const editorElement = activeElement.classList.contains('redactor-editor')
        ? activeElement
        : activeElement.closest('.redactor-editor');

      if (!editorElement) return;

      const figures = editorElement.querySelectorAll('figure.redactor-component');
      let lastEmojiProcessed = null;

      figures.forEach(figure => {
        const img = figure.querySelector('img[src*="emojis"]');
        if (img) {
          // Clone the img and make it like toolbar emojis
          const newImg = img.cloneNode(true);
          newImg.setAttribute('contenteditable', 'true');

          // Replace the entire figure with just the img (like toolbar emojis)
          figure.parentNode.insertBefore(newImg, figure);
          figure.remove();

          lastEmojiProcessed = newImg;
        }
      });

      // Ensure editor maintains focus and watch for re-wrapping
      if (lastEmojiProcessed || figures.length > 0) {
        // Multiple cleanups to catch Redactor's delayed processing
        setTimeout(() => {
          unwrapEmojiImages(editorElement);
          editorElement.focus();
        }, 50);

        setTimeout(() => {
          unwrapEmojiImages(editorElement);
        }, 200);

        setTimeout(() => {
          unwrapEmojiImages(editorElement);
        }, 500);
      }
    }, 100);
  });

  // Add MutationObserver to catch any new figures being created around emojis
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches && node.matches('figure')) {
            const img = node.querySelector('img[src*="emojis"]');
            if (img) {
              setTimeout(() => unwrapEmojiImages(node.parentElement || document.body), 10);
            }
          } else if (node.querySelectorAll) {
            const emojiInFigures = node.querySelectorAll('figure img[src*="emojis"]');
            if (emojiInFigures.length > 0) {
              setTimeout(() => unwrapEmojiImages(node), 10);
            }
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Block-level tags that Redactor can operate on with toolbar actions.
// Inline elements and bare text nodes that are NOT inside one of these must be
// wrapped in <p> before insertion, otherwise bold/lists/etc. silently fail.
const BLOCK_TAGS = new Set([
  'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
  'UL', 'OL', 'LI', 'BLOCKQUOTE', 'PRE',
  'TABLE', 'THEAD', 'TBODY', 'TR', 'TD', 'TH',
  'FIGURE', 'HR'
]);

function stripBlockWrappers(html) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;

  // 1. Strip contenteditable attributes — Slack, Google Docs, and LLM interfaces
  //    embed contenteditable="false" on spans/elements (mentions, code blocks, etc.).
  //    These survive Redactor's cleaner and make pasted content non-editable.
  //    DOM-based removal avoids corrupting text nodes that contain the literal
  //    string contenteditable="false" as visible copy.
  tmp.querySelectorAll('[contenteditable]').forEach(el => el.removeAttribute('contenteditable'));

  // 2. Convert <div> wrappers to <p> so Redactor's list toggle and other toolbar
  //    actions can find block elements to operate on.
  tmp.querySelectorAll('div').forEach(div => {
    const p = document.createElement('p');
    while (div.firstChild) p.appendChild(div.firstChild);
    div.replaceWith(p);
  });

  // 3. Wrap orphan top-level nodes (bare text nodes and inline elements) in <p>.
  //    Without this, content pasted from Slack/LLMs that arrives as e.g.
  //    "some text <span>@mention</span> more text" with no block wrapper can't
  //    be formatted with the toolbar at all.
  const orphans = [];
  const snapshot = Array.from(tmp.childNodes);

  function flushOrphans(insertBefore) {
    if (!orphans.length) return;
    const hasText = orphans.some(n => n.textContent.trim());
    if (hasText) {
      const p = document.createElement('p');
      orphans.forEach(n => p.appendChild(n));
      tmp.insertBefore(p, insertBefore || null);
    } else {
      // whitespace-only orphans — just move them in so they're collected
      orphans.forEach(n => {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
    }
    orphans.length = 0;
  }

  snapshot.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      orphans.push(node);
    } else if (node.nodeType === Node.ELEMENT_NODE && !BLOCK_TAGS.has(node.tagName)) {
      orphans.push(node);
    } else {
      flushOrphans(node);
    }
  });
  flushOrphans(null);

  // 4. Remove empty <p> tags and collapse excessive <br> runs.
  tmp.querySelectorAll('p').forEach(p => {
    if (!p.textContent.trim() && !p.querySelector('img, br')) p.remove();
  });

  let result = tmp.innerHTML;
  result = result.replace(/(<br\s*\/?\s*>){3,}/gi, '<br><br>');
  return result;
}

function setRedactorEditor(options = {}) {
  const { isAdminEditor = false } = options;

  // Base plugins - always included
  const plugins = [
    "alignment",
    "emoji",
    "table",
    "addbutton",
    "nofollow",
    "image",
    "widget",
    "handle",
  ];

  // Base buttons - always included
  const buttons = [
    "format",
    "bold",
    "italic",
    "deleted",
    "underline",
    "lists",
    "link",
    "file",
    "image",
    "horizontalrule",
  ];

  // Add dealcard and embedded plugins/buttons for editors
  if (isAdminEditor) {
    plugins.push("dealcard", "embedded");
    buttons.push("dealcard", "embedded");
  }

  // Cleaner config - allow embeds for editors
  const cleanerTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'ol', 'ul', 'li'];
  if (isAdminEditor) {
    cleanerTags.push('iframe', 'blockquote', 'script', 'a');
  }

  let app = Redactor(".redactor-textarea", {
    lang: document.documentElement.lang || "en",
    plugins: plugins,
    buttons: buttons,
    formatting: ["p", "blockquote", "h1", "h2", "h3", "h4", "h5", "h6"],
    minHeight: "180px",
    linebreaks: true,       // Use line breaks instead of <p> tags
    paragraphize: false,    // Disable automatic <p> wrapping
    replaceDivs: false,
    stylesClass: "redactor-styles",
    toolbarFixed: false,
    handle: "/profile.json",
    imageUpload: "/upload/multiple_images",
    convertImages: false,
    linkAnchor: false,
    autoparse: false,
    linkSize: 30,
    linkNewTab: true,
    linkTarget: '_blank',
    linkNofollow: true,
    cleaner: {
      tags: cleanerTags,
      removeAttributes: isAdminEditor ? false : ['style'],
      keepClasses: true,
      replace: [
        {
          test: /https?:\/\/[^\s]+\.(jpg|jpeg|png|gif|webp)/gi,
          replacement: function(match) {
            return `<span class="image-placeholder" data-original-url="${match}">Loading...</span>`;
          }
        }
      ]
    },
    callbacks: {
      started: function() {
        // DealSnap Extension: sync editor content to textarea
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('dealsnap_id')) {
          const textarea = this.element.getElement().get();
          const editor = document.querySelector('.redactor-box [contenteditable="true"]');
          
          if (editor && textarea) {
            setTimeout(() => {
              const content = editor.innerHTML || '';
              if (content && content.trim() !== '' && content !== '<p><br></p>') {
                textarea.value = content;
              }
            }, 2000);
          }
        }
      },
      pasting: function (html, data) {
        // Skip processing for drag-drop events (let Redactor handle file drops natively)
        if (data && data.type === 'drop') {
          return html;
        }

        // Convert pasted profile links to @username mentions
        // Handles both "@username" and plain "username" text inside profile <a> tags
        html = html.replace(/<a\s+[^>]*href="[^"]*\/profile\/([\p{L}\p{N}._-]+)"[^>]*>@?[\p{L}\p{N}._-]+<\/a>/gu, ' @$1');

        // Check if content already has HTML structure (not plain text)
        const hasHtmlStructure = /<[^>]+>/.test(html);

        // Only process plain text content for pasting
        if (!hasHtmlStructure) {
          // First check for image URLs that need special processing
          const imageUrlRegex = /((https?:\/\/|www\.)[^\s"'<>]+\.(jpe?g|png|gif|webp)(\?[^\s"'<>]*)?)/gi;
          const containsImageUrls = imageUrlRegex.test(html);

          if (containsImageUrls) {
            // Process image URLs with loading divs
            const updatedHtml = replaceURLsWithLoadingDivs(html);
            setTimeout(() => {
              processImageCDN();
              disableSubmitDuringImageUpload();
            }, 0);
            return updatedHtml.replace(/\n/g, "<br>");
          } else {
            // Handle regular URLs (non-image) and make them clickable with truncation
            const urlRegex = /(https?:\/\/[^\s<>]+)/gi;
            html = html.replace(urlRegex, function(url) {
              // Truncate URL display text if too long
              let displayText = url;
              if (url.length > 30) {
                displayText = url.substring(0, 27) + '...';
              }
              return '<a href="' + url + '" target="_blank" rel="nofollow">' + displayText + '</a>';
            });
          }
        }

        // For HTML content with external images, upload them to CDN
        if (/<img[^>]*src\s*=\s*["'][^"']+["'][^>]*>/i.test(html)) {
          const updatedHtml = processExternalImagesInPastedHtml(html);
          setTimeout(() => {
            processImageCDN();
            disableSubmitDuringImageUpload();
          }, 0);
          return stripBlockWrappers(updatedHtml).replace(/\n/g, "<br>");
        }

        return stripBlockWrappers(html).replace(/\n/g, "<br>");
      },
      upload: {
        start: function (e, formData) {
          var all_images;    
          if (e.type === "change") {
            all_images = e.currentTarget.files;
          } else if (e.type === "drop") {
            all_images = e.dataTransfer.files;
          }
          if (all_images && all_images.length > 0) {
            for (var i = 0; i < all_images.length; i++) {
              var file = all_images[i];
              var isValidType = new RegExp(["jpg", "png", "jpeg", "gif", "webp"].join("|")).test(file.type.toLowerCase());
              var isValidSize = file.size <= 10485760;
    
              if (!isValidType || !isValidSize) {
                if (e.type === "change") {
                  e.target.value = "";  // Reset file input
                }
                if (!isValidType) {
                  showToast(I18n.t("redactor_image_type_error"));
                } else if (!isValidSize) {
                  showToast(I18n.t("redactor_image_size_error"));
                }
                return false;  // Prevent further upload
              }
            }
            if (all_images.length > 5) {
              showToast(I18n.t("redactor_image_number_error"));
              if (e.type === "change") {
                e.target.value = "";  // Reset file input
              }
              return false;
            }
          }
        },
      },
      keyup: (event) => {
        let content = event.target.innerHTML;
        let hasReplaced = false;

        // Get the current caret position
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        let cursorPos = range.startOffset;

        for (let symbol in emojiMap) {
          let emojiImageTag = emojiMap[symbol];
          let escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          
          // Special handling for emoticons that start with special characters
          let regex;
          if (symbol.startsWith('>') || symbol.startsWith('^') || symbol.startsWith('-')) {
            // For emoticons starting with special chars, match the whole emoticon
            regex = new RegExp(
              `(^|\\s|&nbsp;|<)(${escapedSymbol})(?=\\s|$|&nbsp;|<)`,
              "gi"
            );
          } else {
            // For regular emoticons, use word boundary approach
            regex = new RegExp(
              `(^|[^\\w])(${escapedSymbol})(?=\\s|$|&nbsp;|<|[^\\w])`,
              "gi"
            );
          }

          // Check if the symbol exists in the content and replace with emoji + space
          if (regex.test(content)) {
            let newContent = content.replace(
              regex,
              `$1${emojiImageTag}&nbsp;`
            );
            let emojiInserted = newContent !== content;

            if (emojiInserted) {
              content = newContent;
              hasReplaced = true;
            }
          }
        }

        // If any emoji has been replaced
        if (hasReplaced) {
          event.target.innerHTML = content;

          // Restore cursor position to the end of the last inserted emoji
          let emojiTags = event.target.getElementsByTagName("img");
          if (emojiTags.length > 0) {
            let lastEmoji = emojiTags[emojiTags.length - 1];

            // Check if there's text node (e.g., a space) after the emoji and set caret after it
            if (
              lastEmoji.nextSibling &&
              lastEmoji.nextSibling.nodeType === Node.TEXT_NODE
            ) {
              range.setStart(lastEmoji.nextSibling, 1); // Position after the space
            } else {
              // If no text node, fallback to after the emoji
              range.setStartAfter(lastEmoji);
            }
          }

          range.collapse(true); // Collapse the range to the new caret position
          selection.removeAllRanges(); // Clear the old selection
          selection.addRange(range); // Apply the new range

          // Prevent default behavior (especially space/enter keys)
          event.preventDefault();
        }
      },
    },
  });
  
  // Setup emoji cleanup for legacy Redactor
  setupLegacyEmojiCleanup();
}

function setRedactorEditorNews() {
  let app = Redactor(".redactor-textarea", {
    lang: getRedactorLang(),
    plugins: [
      "alignment",
      "emoji",
      "table",
      "addbutton",
      "dealcard",
      "embedded",
      // "ads",
      "nofollow",
      "image",
      "widget",
      "handle",
    ],
    buttons: [
      "html",
      "format",
      "bold",
      "italic",
      "deleted",
      "underline",
      "lists",
      "link",
      "file",
      "image",
      "horizontalrule",
      "dealcard",
      "embedded",
      // "ads",
    ],
    formatting: ["p", "blockquote", "h1", "h2", "h3", "h4", "h5", "h6"],
    minHeight: "180px",
    linebreaks: true,       // Use line breaks instead of <p> tags
    paragraphize: false,    // Disable automatic <p> wrapping
    replaceDivs: false,
    stylesClass: "redactor-styles",
    toolbarFixed: false,
    handle: "/profile.json",
    imageUpload: "/upload/multiple_images",
    convertImages: false,
    linkAnchor: false,
    autoparse: false,
    linkSize: 30,
    linkNewTab: true,
    linkTarget: '_blank',
    linkNofollow: true,
    cleaner: {
      tags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'iframe', 'blockquote', 'script', 'a', 'ol', 'ul', 'li'],
      removeAttributes: false,
      keepClasses: true,
      replace: [
        {
          test: /https?:\/\/[^\s]+\.(jpg|jpeg|png|gif|webp)/gi,
          replacement: function(match) {
            return `<span class="image-placeholder" data-original-url="${match}">Loading...</span>`;
          }
        }
      ]
    },
    callbacks: {
      pasting: function (html, data) {
        // Skip processing for drag-drop events (let Redactor handle file drops natively)
        if (data && data.type === 'drop') {
          return html;
        }

        // Convert pasted profile links to @username mentions
        // Handles both "@username" and plain "username" text inside profile <a> tags
        html = html.replace(/<a\s+[^>]*href="[^"]*\/profile\/([\p{L}\p{N}._-]+)"[^>]*>@?[\p{L}\p{N}._-]+<\/a>/gu, ' @$1');

        // Check if content already has HTML structure (not plain text)
        const hasHtmlStructure = /<[^>]+>/.test(html);
        
        // Check if it's a Twitter embed
        const isTwitterEmbed = /<blockquote[\s\S]*class="twitter-tweet"[\s\S]*<\/blockquote>/.test(html);
        if (isTwitterEmbed) {
          // Remove script tags as they'll be loaded separately
          html = html.replace(/<script[\s\S]*?<\/script>/g, '');
          // Initialize Twitter widgets after paste
          setTimeout(() => {
            if (!window.twttr) {
              const script = document.createElement('script');
              script.src = 'https://platform.twitter.com/widgets.js';
              script.charset = 'utf-8';
              script.async = true;
              document.body.appendChild(script);
            } else if (window.twttr.widgets) {
              window.twttr.widgets.load();
            }
          }, 100);
          return html;
        }

        // Only process plain text content for pasting
        if (!hasHtmlStructure) {
          // First check for image URLs that need special processing
          const imageUrlRegex = /((https?:\/\/|www\.)[^\s"'<>]+\.(jpe?g|png|gif|webp)(\?[^\s"'<>]*)?)/gi;
          const containsImageUrls = imageUrlRegex.test(html);

          if (containsImageUrls) {
            // Process image URLs with loading divs
            const updatedHtml = replaceURLsWithLoadingDivs(html);
            setTimeout(() => {
              processImageCDN();
            }, 0);
            return updatedHtml.replace(/\n/g, "<br>");
          } else {
            // Handle regular URLs (non-image) and make them clickable with truncation
            const urlRegex = /(https?:\/\/[^\s<>]+)/gi;
            html = html.replace(urlRegex, function(url) {
              // Truncate URL display text if too long
              let displayText = url;
              if (url.length > 30) {
                displayText = url.substring(0, 27) + '...';
              }
              return '<a href="' + url + '" target="_blank" rel="nofollow">' + displayText + '</a>';
            });
          }
        }

        // For HTML content with external images, upload them to CDN
        if (/<img[^>]*src\s*=\s*["'][^"']+["'][^>]*>/i.test(html)) {
          const updatedHtml = processExternalImagesInPastedHtml(html);
          setTimeout(() => processImageCDN(), 0);
          return stripBlockWrappers(updatedHtml).replace(/\n/g, "<br>");
        }

        return stripBlockWrappers(html).replace(/\n/g, "<br>");
      },
      upload: {
        start: function (e, formData) {
          var all_images;    
          if (e.type === "change") {
            all_images = e.currentTarget.files;
          } else if (e.type === "drop") {
            all_images = e.dataTransfer.files;
          }
          if (all_images && all_images.length > 0) {
            for (var i = 0; i < all_images.length; i++) {
              var file = all_images[i];
              var isValidType = new RegExp(["jpg", "png", "jpeg", "gif", "webp"].join("|")).test(file.type.toLowerCase());
              var isValidSize = file.size <= 10485760;
    
              if (!isValidType || !isValidSize) {
                if (e.type === "change") {
                  e.target.value = "";  // Reset file input
                }
                if (!isValidType) {
                  showToast(I18n.t("redactor_image_type_error"));
                } else if (!isValidSize) {
                  showToast(I18n.t("redactor_image_size_error"));
                }
                return false;  // Prevent further upload
              }
            }
            if (all_images.length > 5) {
              showToast(I18n.t("redactor_image_number_error"));
              if (e.type === "change") {
                e.target.value = "";  // Reset file input
              }
              return false;
            }
          }
        },
      },
      keyup: (event) => {
        let content = event.target.innerHTML;
        let hasReplaced = false;

        // Get the current caret position
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        let cursorPos = range.startOffset;

        for (let symbol in emojiMap) {
          let emojiImageTag = emojiMap[symbol];
          let escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          
          // Special handling for emoticons that start with special characters
          let regex;
          if (symbol.startsWith('>') || symbol.startsWith('^') || symbol.startsWith('-')) {
            // For emoticons starting with special chars, match the whole emoticon
            regex = new RegExp(
              `(^|\\s|&nbsp;|<)(${escapedSymbol})(?=\\s|$|&nbsp;|<)`,
              "gi"
            );
          } else {
            // For regular emoticons, use word boundary approach
            regex = new RegExp(
              `(^|[^\\w])(${escapedSymbol})(?=\\s|$|&nbsp;|<|[^\\w])`,
              "gi"
            );
          }

          // Check if the symbol exists in the content and replace with emoji + space
          if (regex.test(content)) {
            let newContent = content.replace(
              regex,
              `$1${emojiImageTag}&nbsp;`
            );
            let emojiInserted = newContent !== content;

            if (emojiInserted) {
              content = newContent;
              hasReplaced = true;
            }
          }
        }

        // If any emoji has been replaced
        if (hasReplaced) {
          event.target.innerHTML = content;

          // Restore cursor position to the end of the last inserted emoji
          let emojiTags = event.target.getElementsByTagName("img");
          if (emojiTags.length > 0) {
            let lastEmoji = emojiTags[emojiTags.length - 1];

            // Check if there's text node (e.g., a space) after the emoji and set caret after it
            if (
              lastEmoji.nextSibling &&
              lastEmoji.nextSibling.nodeType === Node.TEXT_NODE
            ) {
              range.setStart(lastEmoji.nextSibling, 1); // Position after the space
            } else {
              // If no text node, fallback to after the emoji
              range.setStartAfter(lastEmoji);
            }
          }

          range.collapse(true); // Collapse the range to the new caret position
          selection.removeAllRanges(); // Clear the old selection
          selection.addRange(range); // Apply the new range

          // Prevent default behavior (especially space/enter keys)
          event.preventDefault();
        }
      },
    },
  });
  
  // Setup emoji cleanup for legacy Redactor
  setupLegacyEmojiCleanup();
}

function setRedactorReply() {
  let app = Redactor(".redactor-textarea", {
    lang: getRedactorLang(),
    plugins: ["alignment", "handle", "emoji", "nofollow"],
    buttons: [
      "format",
      "bold",
      "italic",
      "deleted",
      "underline",
      "lists",
      "link",
      "file",
      "image",
      "horizontalrule",
    ],
    formatting: ["p", "blockquote", "h1", "h2", "h3", "h4", "h5", "h6"],
    linebreaks: true,       // Use line breaks instead of <p> tags
    paragraphize: false,    // Disable automatic <p> wrapping
    replaceDivs: false,
    minHeight: "180px",
    stylesClass: "custom-redactor-reply",
    toolbarFixed: false,
    handle: "/profile.json",
    imageUpload: "/upload/multiple_images",
    placeholder: I18n.t("enter_your_comment"),
    
    convertImages: false,
    linkAnchor: false,
    autoparse: false,
    linkSize: 30,
    linkNewTab: true,
    linkTarget: '_blank',
    linkNofollow: true,
    cleaner: {
      tags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'ol', 'ul', 'li'],
      removeAttributes: ['style'],
      keepClasses: true,
      replace: [
        {
          test: /https?:\/\/[^\s]+\.(jpg|jpeg|png|gif|webp)/gi,
          replacement: function(match) {
            return `<span class="image-placeholder" data-original-url="${match}">Loading...</span>`;
          }
        }
      ]
    },
    callbacks: {
      pasting: function (html, data) {
        // Skip processing for drag-drop events (let Redactor handle file drops natively)
        if (data && data.type === 'drop') {
          return html;
        }

        // Convert pasted profile links to @username mentions
        // Handles both "@username" and plain "username" text inside profile <a> tags
        html = html.replace(/<a\s+[^>]*href="[^"]*\/profile\/([\p{L}\p{N}._-]+)"[^>]*>@?[\p{L}\p{N}._-]+<\/a>/gu, ' @$1');

        // Check if content already has HTML structure (not plain text)
        const hasHtmlStructure = /<[^>]+>/.test(html);
        
        // Only process plain text content for pasting
        if (!hasHtmlStructure) {
          // First check for image URLs that need special processing
          const imageUrlRegex = /((https?:\/\/|www\.)[^\s"'<>]+\.(jpe?g|png|gif|webp)(\?[^\s"'<>]*)?)/gi;
          const containsImageUrls = imageUrlRegex.test(html);
          
          if (containsImageUrls) {
            // Process image URLs with loading divs
            const updatedHtml = replaceURLsWithLoadingDivs(html);
            setTimeout(() => {
              processImageCDN();
            }, 0);
            return updatedHtml.replace(/\n/g, "<br>");
          } else {
            // Handle regular URLs (non-image) and make them clickable with truncation
            const urlRegex = /(https?:\/\/[^\s<>]+)/gi;
            html = html.replace(urlRegex, function(url) {
              // Truncate URL display text if too long
              let displayText = url;
              if (url.length > 30) {
                displayText = url.substring(0, 27) + '...';
              }
              return '<a href="' + url + '" target="_blank" rel="nofollow">' + displayText + '</a>';
            });
          }
        }

        // For HTML content with external images, upload them to CDN
        if (/<img[^>]*src\s*=\s*["'][^"']+["'][^>]*>/i.test(html)) {
          const updatedHtml = processExternalImagesInPastedHtml(html);
          setTimeout(() => processImageCDN(), 0);
          return stripBlockWrappers(updatedHtml).replace(/\n/g, "<br>");
        }

        return stripBlockWrappers(html).replace(/\n/g, "<br>");
      },
      upload: {
        start: function (e, formData) {
          var all_images;    
          if (e.type === "change") {
            all_images = e.currentTarget.files;
          } else if (e.type === "drop") {
            all_images = e.dataTransfer.files;
          }
          if (all_images && all_images.length > 0) {
            for (var i = 0; i < all_images.length; i++) {
              var file = all_images[i];
              var isValidType = new RegExp(["jpg", "png", "jpeg", "gif", "webp"].join("|")).test(file.type.toLowerCase());
              var isValidSize = file.size <= 10485760;
    
              if (!isValidType || !isValidSize) {
                if (e.type === "change") {
                  e.target.value = "";  // Reset file input
                }
                if (!isValidType) {
                  showToast(I18n.t("redactor_image_type_error"));
                } else if (!isValidSize) {
                  showToast(I18n.t("redactor_image_size_error"));
                }
                return false;  // Prevent further upload
              }
            }
            if (all_images.length > 5) {
              showToast(I18n.t("redactor_image_number_error"));
              if (e.type === "change") {
                e.target.value = "";  // Reset file input
              }
              return false;
            }
          }
        },
      },
      keyup: (event) => {
        let content = event.target.innerHTML;
        let hasReplaced = false;

        // Get the current caret position
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        let cursorPos = range.startOffset;

        for (let symbol in emojiMap) {
          let emojiImageTag = emojiMap[symbol];
          let escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          
          // Special handling for emoticons that start with special characters
          let regex;
          if (symbol.startsWith('>') || symbol.startsWith('^') || symbol.startsWith('-')) {
            // For emoticons starting with special chars, match the whole emoticon
            regex = new RegExp(
              `(^|\\s|&nbsp;|<)(${escapedSymbol})(?=\\s|$|&nbsp;|<)`,
              "gi"
            );
          } else {
            // For regular emoticons, use word boundary approach
            regex = new RegExp(
              `(^|[^\\w])(${escapedSymbol})(?=\\s|$|&nbsp;|<|[^\\w])`,
              "gi"
            );
          }

          // Check if the symbol exists in the content and replace with emoji + space
          if (regex.test(content)) {
            let newContent = content.replace(
              regex,
              `$1${emojiImageTag}&nbsp;`
            );
            let emojiInserted = newContent !== content;

            if (emojiInserted) {
              content = newContent;
              hasReplaced = true;
            }
          }
        }

        // If any emoji has been replaced
        if (hasReplaced) {
          event.target.innerHTML = content;

          // Restore cursor position to the end of the last inserted emoji
          let emojiTags = event.target.getElementsByTagName("img");
          if (emojiTags.length > 0) {
            let lastEmoji = emojiTags[emojiTags.length - 1];

            // Check if there's text node (e.g., a space) after the emoji and set caret after it
            if (
              lastEmoji.nextSibling &&
              lastEmoji.nextSibling.nodeType === Node.TEXT_NODE
            ) {
              range.setStart(lastEmoji.nextSibling, 1); // Position after the space
            } else {
              // If no text node, fallback to after the emoji
              range.setStartAfter(lastEmoji);
            }
          }

          range.collapse(true); // Collapse the range to the new caret position
          selection.removeAllRanges(); // Clear the old selection
          selection.addRange(range); // Apply the new range

          // Prevent default behavior (especially space/enter keys)
          event.preventDefault();
        }
      },
    },
  });
  
  // Setup emoji cleanup for legacy Redactor
  setupLegacyEmojiCleanup();
}

function setRedactorAdmin() {
  let app = Redactor(".redactor-textarea", {
    lang: getRedactorLang(),
    plugins: [
      "alignment",
      "emoji",
      "table",
      "addbutton",
      "nofollow",
      "image",
      "widget",
    ],
    buttons: [
      "html",
      "format",
      "bold",
      "italic",
      "deleted",
      "underline",
      "lists",
      "link",
      "file",
      "image",
      "horizontalrule",
    ],
    formatting: ["p", "blockquote", "h1", "h2", "h3", "h4", "h5", "h6"],
    linebreaks: true,       // Use line breaks instead of <p> tags
    paragraphize: false,    // Disable automatic <p> wrapping
    replaceDivs: false ,
    minHeight: "180px",
    stylesClass: "redactor-styles",
    toolbarFixed: false,
    imageUpload: "/upload/multiple_images",
    convertImages: false,
    linkAnchor: false,
    autoparse: false,
    linkSize: 30,
    linkNewTab: true,
    linkTarget: '_blank',
    linkNofollow: true,
    cleaner: {
      tags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'ol', 'ul', 'li'],
      removeAttributes: ['style'],
      keepClasses: true,
      replace: [
        {
          test: /https?:\/\/[^\s]+\.(jpg|jpeg|png|gif|webp)/gi,
          replacement: function(match) {
            return `<span class="image-placeholder" data-original-url="${match}">Loading...</span>`;
          }
        }
      ]
    },
    callbacks: {
      pasting: function (html, data) {
        // Skip processing for drag-drop events (let Redactor handle file drops natively)
        if (data && data.type === 'drop') {
          return html;
        }

        // Convert pasted profile links to @username mentions
        // Handles both "@username" and plain "username" text inside profile <a> tags
        html = html.replace(/<a\s+[^>]*href="[^"]*\/profile\/([\p{L}\p{N}._-]+)"[^>]*>@?[\p{L}\p{N}._-]+<\/a>/gu, ' @$1');

        // Check if content already has HTML structure (not plain text)
        const hasHtmlStructure = /<[^>]+>/.test(html);
        
        // Only process plain text content for pasting
        if (!hasHtmlStructure) {
          // First check for image URLs that need special processing
          const imageUrlRegex = /((https?:\/\/|www\.)[^\s"'<>]+\.(jpe?g|png|gif|webp)(\?[^\s"'<>]*)?)/gi;
          const containsImageUrls = imageUrlRegex.test(html);
          
          if (containsImageUrls) {
            // Process image URLs with loading divs
            const updatedHtml = replaceURLsWithLoadingDivs(html);
            setTimeout(() => {
              processImageCDN();
            }, 0);
            return updatedHtml.replace(/\n/g, "<br>");
          } else {
            // Handle regular URLs (non-image) and make them clickable with truncation
            const urlRegex = /(https?:\/\/[^\s<>]+)/gi;
            html = html.replace(urlRegex, function(url) {
              // Truncate URL display text if too long
              let displayText = url;
              if (url.length > 30) {
                displayText = url.substring(0, 27) + '...';
              }
              return '<a href="' + url + '" target="_blank" rel="nofollow">' + displayText + '</a>';
            });
          }
        }

        // For HTML content with external images, upload them to CDN
        if (/<img[^>]*src\s*=\s*["'][^"']+["'][^>]*>/i.test(html)) {
          const updatedHtml = processExternalImagesInPastedHtml(html);
          setTimeout(() => processImageCDN(), 0);
          return stripBlockWrappers(updatedHtml).replace(/\n/g, "<br>");
        }

        return stripBlockWrappers(html).replace(/\n/g, "<br>");
      },
      upload: {
        start: function (e, formData) {
          var all_images;    
          if (e.type === "change") {
            all_images = e.currentTarget.files;
          } else if (e.type === "drop") {
            all_images = e.dataTransfer.files;
          }
          if (all_images && all_images.length > 0) {
            for (var i = 0; i < all_images.length; i++) {
              var file = all_images[i];
              var isValidType = new RegExp(["jpg", "png", "jpeg", "gif", "webp"].join("|")).test(file.type.toLowerCase());
              var isValidSize = file.size <= 10485760;
    
              if (!isValidType || !isValidSize) {
                if (e.type === "change") {
                  e.target.value = "";  // Reset file input
                }
                if (!isValidType) {
                  showToast(I18n.t("redactor_image_type_error"));
                } else if (!isValidSize) {
                  showToast(I18n.t("redactor_image_size_error"));
                }
                return false;  // Prevent further upload
              }
            }
            if (all_images.length > 5) {
              showToast(I18n.t("redactor_image_number_error"));
              if (e.type === "change") {
                e.target.value = "";  // Reset file input
              }
              return false;
            }
          }
        },
      },
      keyup: (event) => {
        let content = event.target.innerHTML;
        let hasReplaced = false;

        // Get the current caret position
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        let cursorPos = range.startOffset;

        for (let symbol in emojiMap) {
          let emojiImageTag = emojiMap[symbol];
          let escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          
          // Special handling for emoticons that start with special characters
          let regex;
          if (symbol.startsWith('>') || symbol.startsWith('^') || symbol.startsWith('-')) {
            // For emoticons starting with special chars, match the whole emoticon
            regex = new RegExp(
              `(^|\\s|&nbsp;|<)(${escapedSymbol})(?=\\s|$|&nbsp;|<)`,
              "gi"
            );
          } else {
            // For regular emoticons, use word boundary approach
            regex = new RegExp(
              `(^|[^\\w])(${escapedSymbol})(?=\\s|$|&nbsp;|<|[^\\w])`,
              "gi"
            );
          }

          // Check if the symbol exists in the content and replace with emoji + space
          if (regex.test(content)) {
            let newContent = content.replace(
              regex,
              `$1${emojiImageTag}&nbsp;`
            );
            let emojiInserted = newContent !== content;

            if (emojiInserted) {
              content = newContent;
              hasReplaced = true;
            }
          }
        }

        // If any emoji has been replaced
        if (hasReplaced) {
          event.target.innerHTML = content;

          // Restore cursor position to the end of the last inserted emoji
          let emojiTags = event.target.getElementsByTagName("img");
          if (emojiTags.length > 0) {
            let lastEmoji = emojiTags[emojiTags.length - 1];

            // Check if there's text node (e.g., a space) after the emoji and set caret after it
            if (
              lastEmoji.nextSibling &&
              lastEmoji.nextSibling.nodeType === Node.TEXT_NODE
            ) {
              range.setStart(lastEmoji.nextSibling, 1); // Position after the space
            } else {
              // If no text node, fallback to after the emoji
              range.setStartAfter(lastEmoji);
            }
          }

          range.collapse(true); // Collapse the range to the new caret position
          selection.removeAllRanges(); // Clear the old selection
          selection.addRange(range); // Apply the new range

          // Prevent default behavior (especially space/enter keys)
          event.preventDefault();
        }
      },
    },
  });
}

function placeCaretAtEnd(el) {
  el.focus();
  if (
    typeof window.getSelection !== "undefined" &&
    typeof document.createRange !== "undefined"
  ) {
    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }
}

function imageLoadingSpan(url) {
  return `<span class="image-loading" data-original-url="${url}" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;min-height:80px;background:#f3f4f6;border-radius:6px;margin:4px 0;padding:12px;"><span class="w-6 h-6 border-4 border-t-transparent border-gray-400 border-solid rounded-full animate-spin" style="flex-shrink:0;"></span><span style="font-size:12px;color:#9ca3af;">${I18n.t("loading")}...</span></span>`;
}

function replaceURLsWithLoadingDivs(html) {
  // Skip processing if content already has HTML tags (except basic formatting)
  // This prevents processing of already formatted content, emojis, etc.
  if (/<img[^>]*>|<span[^>]*class="[^"]*emoji[^"]*"[^>]*>|<figure[^>]*>/.test(html)) {
    return html;
  }

  // This regex matches direct image URLs (ending with .jpg, .jpeg, .png, .gif, .webp)
  // and also matches Reddit preview URLs that end with an image extension (with or without query params)
  // Modified to be more precise and avoid matching URLs within HTML attributes
  const imageUrlRegex = /(?<![="'])((https?:\/\/|www\.)[^\s"'<>]+\.(jpe?g|png|gif|webp)(\?[^\s"'<>]*)?)/gi;

  // Replace direct image URLs (including Reddit preview URLs), but not ones already inside a span
  html = html.replace(imageUrlRegex, (url) => {
    // Avoid double-wrapping if already inside a span
    if (html.includes(`<span class="image-loading" data-original-url="${url}"`)) {
      return url;
    }

    return imageLoadingSpan(url);
  });
  return html;
}

function processExternalImagesInPastedHtml(html) {
  const cdnRegex = /cdndev\.desidime\.com|cdn\d\.desidime\.com|cdn\d\.pepperrussia\.com|cdn\d\.pepper\.ru|cdnyc\.pepper\.ru/i;
  return html.replace(/<img([^>]*?)src\s*=\s*["']([^"']+)["']([^>]*?)>/gi, function(match, before, src, after) {
    if (cdnRegex.test(src) || src.startsWith('data:') || src.includes('/emojis/') || src.includes('emoji')) {
      return match;
    }
    return imageLoadingSpan(src);
  });
}

function processImageCDN() {
  const loadingDivs = document.querySelectorAll('.image-loading[data-original-url]');
  loadingDivs.forEach((div) => {
    const originalUrl = div.getAttribute('data-original-url');

    // Skip processing emoji images
    if (originalUrl.includes('/emojis/') || originalUrl.includes('emoji')) {
      div.replaceWith(originalUrl); // Just show the original URL
      return;
    }

    const isRedditImage = /^https?:\/\/(preview\.redd\.it|i\.redd\.it|external-preview\.redd\.it)\//.test(originalUrl);

    if (isRedditImage) {
      // Reddit images need server-side proxy due to CORS
      uploadExternalImage(div, originalUrl);
    } else {
      // Try canvas approach for non-Reddit images
      processCanvasImage(div, originalUrl);
    }
  });
}

function uploadExternalImage(div, imageUrl) {
  const filename = extractFilename(imageUrl) || "external-image.jpg";
  const formData = new FormData();
  formData.append("file[]", new Blob(['proxy'], {type: 'text/plain'}), "dummy.txt");
  formData.append("external_url", imageUrl);
  formData.append("external_filename", filename);

  uploadToServer(formData)
    .then(data => {
      const url = data["file-1"]?.url;
      if (url) replaceLoadingDivWithImage(div, url);
      else throw new Error("No URL in response");
    })
    .catch(error => {
      replaceLoadingDivWithImage(div, imageUrl); // Fallback to original URL
    });
}

function processCanvasImage(div, imageUrl) {
  const img = new Image();
  img.crossOrigin = "anonymous";

  img.onload = function() {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    canvas.getContext('2d').drawImage(img, 0, 0);

    canvas.toBlob(function(blob) {
      if (!blob) {
        div.innerHTML = I18n.t("failed_to_process_image");
        div.classList.add("upload-error");
        return;
      }

      const filename = extractFilename(imageUrl) || "pasted-image.jpg";
      const formData = new FormData();
      formData.append("file[]", blob, filename);

      uploadToServer(formData)
        .then(data => {
          const url = data["file-1"]?.url;
          if (url) replaceLoadingDivWithImage(div, url);
          else throw new Error("No URL in response");
        })
        .catch(error => {
          div.innerHTML = I18n.t("failed_to_upload_image");
          div.classList.add("upload-error");
        });
    }, 'image/jpeg', 0.9);
  };
  
  img.onerror = function() {
    replaceLoadingDivWithImage(div, imageUrl); // Fallback to original URL
  };
  
  img.src = imageUrl;
}

function extractFilename(url) {
  try {
    const pathname = new URL(url).pathname;
    const filename = pathname.split('/').pop().split('?')[0];
    if (filename && filename.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
      return filename;
    } else if (filename && filename.length > 0) {
      return filename + '.jpg';
    } else {
      return `image-${Date.now()}.jpg`;
    }
  } catch (e) {
    return `image-${Date.now()}.jpg`;
  }
}

function uploadToServer(formData) {
  return fetch("/upload/multiple_images", {
    method: "POST",
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json"
    },
    credentials: 'same-origin',
    body: formData
  }).then(response => response.json());
}

function replaceLoadingDivWithImage(div, newUrl) {
  const figure = document.createElement("figure");
  figure.className = "redactor-component redactor-uploaded-figure";
  figure.setAttribute("data-redactor-type", "image");
  figure.setAttribute("tabindex", "-1");
  figure.setAttribute("contenteditable", "false");
  const caretSpan = document.createElement("span");
  caretSpan.className = "redactor-component-caret";
  caretSpan.setAttribute("contenteditable", "true");
  caretSpan.innerHTML = "&#xFEFF;";
  const imgTag = document.createElement("img");
  imgTag.src = newUrl;
  imgTag.setAttribute("data-image", "");
  imgTag.alt = "Uploaded Image";
  figure.appendChild(caretSpan);
  figure.appendChild(imgTag);
  div.replaceWith(figure);
}




function disableSubmitDuringImageUpload() {
  const submitBtn = document.querySelector('#topic_submission, #coupon_submission');
  if (!submitBtn) return;

  submitBtn.disabled = true;

  // Start polling after a short delay to let Redactor finish inserting the pasted HTML
  setTimeout(() => {
    const checkInterval = setInterval(() => {
      if (document.querySelectorAll('.image-loading[data-original-url]:not(.upload-error)').length === 0) {
        clearInterval(checkInterval);
        submitBtn.disabled = false;
      }
    }, 500);

    setTimeout(() => {
      clearInterval(checkInterval);
      submitBtn.disabled = false;
    }, 30000);
  }, 300);
}

export { setRedactorEditor, setRedactorReply, setRedactorAdmin, setRedactorEditorNews };
